import React from 'react';
import { InfoTip } from './InfoTip';
type SectionTitleProps = {
  children: string;
  info?: boolean;
  action?: React.ReactNode;
};
export function SectionTitle({
  children,
  info,
  action
}: SectionTitleProps) {
  return <div className="flex items-center justify-between pb-[3px] pt-[9px]" data-id="element-883" data-mp="rlf3rjqc0az0">
      <h3 className="text-[13.5px] font-bold text-pf-ink" data-id="element-884" data-mp="nlepq075a1sh">{children}</h3>
      {info && <InfoTip label={`About ${children}`} data-id="element-885" data-mp="ilsdnu31yrl9" />}
      {action}
    </div>;
}